import { Card, Button } from "react-bootstrap";
import styles from "../outlets/SessionHistoryDetailView.module.css";

const SessionActionButtons = ({
  onBack,
  isSigned = false,
  addAddendum = false,
  isSubmit = false,
  saving = false,
  signingAndSubmitting = false,
  saveStatus = "Save",
  canEditAddendum = false,
  onSave,
  onEdit,
  onAddAddendum,
  onEditAddendum,
  onDownload,
  onAddendumSubmit,
  onSignAndSubmit,
  showSubmitAndPreview = false, // For FollowUp page
  onSubmitAndPreview, // For FollowUp page
  editExistingAddendum = false, // Flag from SessionHistory when editing existing addendum
}) => {
  return (
    <Card className={styles.backButtonCard}>
      <div className={styles.backButtonContainer} onClick={onBack}>
        <div className={styles.backButtonIcon}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <span className={styles.backButtonText}>Back</span>
      </div>
      <div className={styles.actionButtonsContainer} onClick={(e) => e.stopPropagation()}>
        {/* For FollowUp page - check addAddendum first, then canEditAddendum, then isSigned */}
        {showSubmitAndPreview && addAddendum && editExistingAddendum && canEditAddendum ? (
          <>
            <Button
              variant="success"
              className={styles.addAddendumButton}
              onClick={onEditAddendum}
            >
              Edit Addendum
            </Button>
          </>
        ) : showSubmitAndPreview && addAddendum ? (
          <>
            <Button
              variant="success"
              className={styles.saveButton}
              onClick={onSave}
              disabled={saving || saveStatus === "Saved"}
            >
              {saveStatus}
            </Button>
            <Button
              variant="primary"
              className={styles.signSubmitButton}
              onClick={onAddendumSubmit}
              disabled={signingAndSubmitting}
            >
              {signingAndSubmitting ? "Submitting..." : "Submit & Preview"}
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <circle cx="11.3013" cy="11.3013" r="10.8013" fill="white" fillOpacity="0.1" stroke="white" />
                  <path d="M11.0703 7.38037L15.2218 11.5319L11.0703 15.2221" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path opacity="0.5" d="M7.99927 8.44507L11.2282 11.6197L7.99927 14.4417" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </Button>
          </>
        ) : showSubmitAndPreview && isSubmit && canEditAddendum ? (
          <>
            <Button
              variant="success"
              className={styles.addAddendumButton}
              onClick={onEditAddendum}
            >
              Edit Addendum
            </Button>
          </>
        ) : showSubmitAndPreview && isSigned ? (
          <>
            <Button
              variant="success"
              className={styles.downloadButton}
              onClick={onDownload}
            >
              Download
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: "8px" }}>
                <path d="M8 11V1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 7L8 11L12 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1 15H15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Button>
            <Button
              variant="success"
              className={styles.addAddendumButton}
              onClick={onAddAddendum}
            >
              Add Addendum
            </Button>
          </>
        ) : showSubmitAndPreview && isSubmit ? (
          <>
            <Button
              variant="success"
              className={styles.saveButton}
              onClick={onEdit}
            >
              Edit
            </Button>
          </>
        ) : showSubmitAndPreview ? (
          <>
            <Button
              variant="success"
              className={styles.saveButton}
              onClick={onSave}
              disabled={saving || saveStatus === "Saved"}
            >
              {saveStatus}
            </Button>
            <Button
              variant="primary"
              className={styles.signSubmitButton}
              onClick={onSubmitAndPreview}
              disabled={signingAndSubmitting}
            >
              {signingAndSubmitting ? "Submitting..." : "Submit & Preview"}
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <circle cx="11.3013" cy="11.3013" r="10.8013" fill="white" fillOpacity="0.1" stroke="white" />
                  <path d="M11.0703 7.38037L15.2218 11.5319L11.0703 15.2221" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path opacity="0.5" d="M7.99927 8.44507L11.2282 11.6197L7.99927 14.4417" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </Button>
          </>
        ) : isSigned && addAddendum && editExistingAddendum && canEditAddendum ? (
          <>
            <Button
              variant="success"
              className={styles.addAddendumButton}
              onClick={onEditAddendum}
            >
              Edit Addendum
            </Button>
          </>
        ) : isSigned && addAddendum ? (
          <>
            <Button
              variant="success"
              className={styles.saveButton}
              onClick={onSave}
              disabled={saving || saveStatus === "Saved"}
            >
              {saveStatus}
            </Button>
            <Button
              variant="primary"
              className={styles.signSubmitButton}
              onClick={(e) => {
                e.stopPropagation();
                if (addAddendum) {
                  onAddendumSubmit?.(e);
                } else {
                  onSignAndSubmit?.(e);
                }
              }}
              disabled={signingAndSubmitting}
            >
              {signingAndSubmitting ? "Submitting..." : "Submit & Preview"}
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <circle cx="11.3013" cy="11.3013" r="10.8013" fill="white" fillOpacity="0.1" stroke="white" />
                  <path d="M11.0703 7.38037L15.2218 11.5319L11.0703 15.2221" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path opacity="0.5" d="M7.99927 8.44507L11.2282 11.6197L7.99927 14.4417" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </Button>
          </>
        ) : isSigned ? (
          <>
            {canEditAddendum ? (
              <Button
                variant="success"
                className={styles.addAddendumButton}
                onClick={onEditAddendum}
              >
                Edit Addendum
              </Button>
            ) : (
              <>
                <Button
                  variant="success"
                  className={styles.downloadButton}
                  onClick={onDownload}
                >
                  Download
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: "8px" }}>
                    <path d="M8 11V1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4 7L8 11L12 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1 15H15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Button>
                <Button
                  variant="success"
                  className={styles.addAddendumButton}
                  onClick={onAddAddendum}
                >
                  Add Addendum
                </Button>
              </>
            )}
          </>
        ) : isSubmit ? (
          <Button
            variant="success"
            className={styles.saveButton}
            onClick={onEdit}
          >
            Edit
          </Button>
        ) : (
          <>
            <Button
              variant="success"
              className={styles.saveButton}
              onClick={onSave}
              disabled={saving || saveStatus === "Saved"}
            >
              {saveStatus}
            </Button>
            <Button
              variant="primary"
              className={styles.signSubmitButton}
              onClick={(e) => {
                e.stopPropagation();
                onSignAndSubmit?.(e);
              }}
              disabled={signingAndSubmitting}
            >
              {signingAndSubmitting ? "Submitting..." : "Sign & Submit"}
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <circle cx="11.3013" cy="11.3013" r="10.8013" fill="white" fillOpacity="0.1" stroke="white" />
                  <path d="M11.0703 7.38037L15.2218 11.5319L11.0703 15.2221" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path opacity="0.5" d="M7.99927 8.44507L11.2282 11.6197L7.99927 14.4417" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </Button>
          </>
        )}
      </div>
    </Card>
  );
};

export default SessionActionButtons;

